import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';

import css from './IconPlus.module.css';

const IconPlus = props => {
  const { className, rootClassName, isOpen } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classNames(classes, css.chevron, { [css.chevronOpen]: isOpen })}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3 5L7 9L11 5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

IconPlus.defaultProps = {
  className: null,
  rootClassName: null,
  isOpen: true,
};

IconPlus.propTypes = {
  className: string,
  rootClassName: string,
  isOpen: bool,
};

export default IconPlus;
